import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { fetcher } from 'api/client';
import { updateTenant } from 'api/actions/tenant';
import { updateProfile } from 'api/actions/profile';
import { useProfileState } from 'context/profile';
import Dropzone from 'react-dropzone';
import { uploadFileV2 } from 'api/actions/file';
import { Col, FormGroup, Row } from 'reactstrap';

export default function TenantConfiguration() {
    const { t } = useTranslation();
    const { register, handleSubmit, errors, setError} = useForm();
    const queryClient = useQueryClient();
    const { mutate: tenantMutation } = useMutation((payload) => fetcher(updateTenant(payload)), {
        onSuccess: () => {
            queryClient.invalidateQueries('profile');
            // toast.success(t('success'));
        }
    });

    const { mutate: profileMutation } = useMutation((payload) => fetcher(updateProfile(payload)), {
        onSuccess: () => {
            queryClient.invalidateQueries('profile');
            // toast.success(t('success'));
        }
    });

    const onDrop = async (files) => {
        const result = await fetcher(uploadFileV2(files[0]))
        tenantMutation({ logo: result.url })
    }

    const changeExpire = (e) => {
        tenantMutation({ expirationDaysFilter: e.target.value })
    }

    const onSubmit = (payload) => {
        profileMutation(payload)
    }
    const { profile } = useProfileState();
    const buttonRef = useRef();

    const doSubmit = () => buttonRef.current.click()

    return (
        <form onSubmit={handleSubmit(onSubmit)}>

            <h5 className="mb-3">
                <i className="fas fa-building"></i> {t('profile.office.config')}
            </h5>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <label>{t('profile.office.name')}</label>
                        <input
                            ref={register}
                            onBlur={doSubmit}
                            type="text"
                            className="form-control"
                            placeholder={t('profile.office.name_placeholder')}
                            autoComplete="new-name"
                            defaultValue={profile?.office?.name}
                            name="office.name" title="{{ word 'wordList.plans.availablePE')}" />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <label>{t('profile.office.representative')}</label>
                        <input
                            ref={register}
                            onBlur={doSubmit}
                            type="text"
                            className="form-control"
                            placeholder={t('profile.office.representative_placeholder')}
                            autoComplete="new-name"
                            defaultValue={profile?.office?.representative}
                            name="office.representative" />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <label>{t('profile.office.website')}</label>
                        <input
                            ref={register}
                            onBlur={doSubmit}
                            type="text"
                            className="form-control"
                            placeholder={t('profile.office.website_placeholder')}
                            autoComplete="new-phone"
                            defaultValue={profile?.office?.website}
                            name="office.website" />
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <div className="col-md-12">
                    <FormGroup>
                        <label>{t('profile.office.description')}</label>
                        <input
                            ref={register}
                            onBlur={doSubmit}
                            type="text"
                            className="form-control"
                            placeholder={t('profile.office.description_placeholder')}
                            autoComplete="description_placeholder"
                            defaultValue={profile?.office?.description}
                            name="office.description"  
                        />
                    </FormGroup>
                </div>

                <hr></hr>
            </Row>
            <Row>
                <Col md="12">
                <h5 className="mb-3">
                    <i className="fas fa-cog"></i> {t('profile.office.config_notifications')}
                </h5>
                    <FormGroup className="form-inline">
                        <label>{t('profile.office.expiring')}</label>
                        <input
                            style={{width:'75px'}}
                            onBlur={changeExpire}
                            type="number"
                            className="form-control mx-2"
                            placeholder={t('profile.office.expiring_placeholder')}
                            defaultValue={profile?.tenant?.expirationDaysFilter}
                            name="expirationDaysFilter"/>
                        <label class="form-inline" for="inlineFormCheck">
                            {t('profile.office.days')}
                        </label>
                    </FormGroup>
                </Col>
            </Row>
            <hr></hr>
            <h5 className="mb-3">
                <i className="fas fa-image"></i> {t('profile.office.logo')}
            </h5>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Row>
                            <Col className="text-center">
                                {/* <input type="file" className="trato-input" id="office-logo" name="office.logo" data-action="logo" {{#cant 'CHANGE_LOGO')}disabled title="{{word 'wordList.plans.availablePE')}"{{/cant)}> */}
                                <span><small>{t('profile.office.logo_note')}</small></span>

                                <Dropzone accept='image/*' onDrop={(files) => onDrop(files)} multiple={false}>
                                    {({ getRootProps, getInputProps }) => (
                                        <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            {/* <div className="office-img-container border pointer"> */}
                                            <img width="300px" height="100px" className="office-img border pointer" src={profile?.office?.logo || '/images/no-office-logo.png'} alt="logo" />
                                            {/* </div> */}
                                        </div>
                                    )}
                                </Dropzone>

                                <small className="text-danger">*{t('profile.admin.logo')} <span className="font-weight-bold">300x100 {t('profile.admin.pixels')}.</span></small>
                            </Col>
                        </Row>
                    </FormGroup>
                </Col>
            </Row>
            <button type="submit" className="btn btn-primary d-none" ref={buttonRef} hidden={true}>{t('profile.save')}</button>
            <div className="divider"></div>

        </form>

    )
}